import { useEffect, useState } from "react";

/** Throttled scroll state for the navbar and scroll-to-top button. */
export function useScrollPosition(offset = 60) {
  const [state, setState] = useState({ y: 0, isScrolled: false, progress: 0 });

  useEffect(() => {
    let frame = null;

    const update = () => {
      const y = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;

      setState({
        y,
        isScrolled: y > offset,
        progress: max > 0 ? Math.min(y / max, 1) : 0,
      });

      frame = null;
    };

    const onScroll = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [offset]);

  return state;
}

export default useScrollPosition;
